import { App } from 'vue'
import Tree from './LpTree.vue'

Tree.install = (Vue: App) => {
  Vue.component(Tree.name, Tree)
}

export default Tree
